import { render, staticRenderFns } from "./list-value-delete-and-replace-form.vue?vue&type=template&id=519f0492&"
import script from "./list-value-delete-and-replace-form.vue?vue&type=script&lang=js&"
export * from "./list-value-delete-and-replace-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports